import { render, staticRenderFns } from "./MyLoansScheduleDetails.vue?vue&type=template&id=36eb9575"
import script from "./MyLoansScheduleDetails.vue?vue&type=script&lang=js"
export * from "./MyLoansScheduleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports